// extracted by mini-css-extract-plugin
export default {"readOnly":"exHJNm","disabled":"wyTVXh"};